// extracted by mini-css-extract-plugin
export default {"hidden":"Feedback__hidden--CxABK","container":"Feedback__container--Q0grk","emptyResultsContainer":"Feedback__emptyResultsContainer--wsTjo"};